import { render } from "./FallRiskTag.vue?vue&type=template&id=3161ee8a"
import script from "./FallRiskTag.vue?vue&type=script&lang=js"
export * from "./FallRiskTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__